// extracted by mini-css-extract-plugin
module.exports = {"container":"_1h93Sfv","image":"_2X4KVB_","title":"_2kBAfNq","text":"_1nnMP7n"};